import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { getData } from "src/utils/axios/serverHelper";
import { formatDate } from "src/utils/string/stringUtil";
import {
    SAL2060_R01HeaderDto,
    SAL2060_R01DetailDto,
    SAL2060_R01Filter,
} from "./Dto_SAL2060_R01";

const baseUrl = `${config.apiUrl}/SAL2060_R01`;

/**
 * 검색 조건을 Query String으로 변환
 * DateRange (Date 객체)를 YYYY-MM-DD 문자열로 변환 (KST 기준)
 */
const getParams = (filter: SAL2060_R01Filter) => {
    // 품목코드가 입력되었는지 확인 (빈 문자열 제외)
    const itemCd = filter.itemCd && filter.itemCd.trim() !== '' 
        ? filter.itemCd.trim() 
        : undefined;
    
    return {
        compCd: filter.compCd || undefined,
        startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
        endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
        customCd: filter.customCd || undefined,
        itemCd: itemCd, // 품목코드 검색 조건 (빈 문자열 제외)
    };
};

/**
 * 거래처별 매출 집계 조회 (Header)
 */
export const getSAL2060_R01HeaderList = async (
    filter: SAL2060_R01Filter,
    option: string = "search"
) => {
    const url = option ? `${baseUrl}/header/${option}` : `${baseUrl}/header`;
    return await getData<ResponseDto<SAL2060_R01HeaderDto[]>>(url, { 
        params: getParams(filter) 
    });
};

/**
 * 거래처별 매출 집계 전체 건수
 */
export const getSAL2060_R01HeaderAllCount = async (
    filter: SAL2060_R01Filter
) => {
    const url = `${baseUrl}/header/allCount`;
    return await getData<ResponseDto<number>>(url, { 
        params: getParams(filter) 
    });
};

/**
 * 거래처별 매출 상세 조회 (Detail)
 */
export const getSAL2060_R01DetailList = async (
    customCd: string,
    filter: SAL2060_R01Filter,
    option: string = "search"
) => {
    const url = option 
        ? `${baseUrl}/detail/${customCd}/${option}` 
        : `${baseUrl}/detail/${customCd}`;
    return await getData<ResponseDto<SAL2060_R01DetailDto[]>>(url, { 
        params: getParams(filter) 
    });
};

/**
 * 거래처별 매출 상세 전체 건수
 */
export const getSAL2060_R01DetailAllCount = async (
    customCd: string,
    filter: SAL2060_R01Filter
) => {
    const url = `${baseUrl}/detail/${customCd}/allCount`;
    return await getData<ResponseDto<number>>(url, { 
        params: getParams(filter) 
    });
};

/**
 * 거래처별 매출현황 엑셀 다운로드
 */
export const downloadExcel_SAL2060_R01 = async (filter: SAL2060_R01Filter) => {
    const url = `${baseUrl}/excel/search`;
    return await getData<ResponseDto<string | number[]>>(url, {
        params: getParams(filter)
    });
};
